import React, {useState} from 'react';
import SaveDashboardPopup from './SaveDashboardPopup';

function SavingWrapper({pageMeta, children}) {
  // sd-TODO: see if this is not required since we only need the data here, it could be initialised elsewhere
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <div onClick={() => {setIsPopupOpen(true)}}>
        {children}
      </div>

      {
        isPopupOpen ? (
          <SaveDashboardPopup
            isPopupOpen={isPopupOpen}
            closePopup={() => setIsPopupOpen(false)}
            pageMeta={pageMeta}
          />
        ) : null
      }
    </>
  );
}

export default SavingWrapper;